export enum PRICE_ALERT_TYPE {
  percentage = 'percentage',
  price = 'price',
}

export enum PRICE_ALERT_OPERATOR {
  equalOrGreaterThan = 'greater',
  equalOrLessThan = 'less',
  both = 'both',
}

export interface PriceAlert {
  id: string;
  user_name: string;
  account_id: string;
  is_sic: boolean;
  issue_id: string;
  type: PRICE_ALERT_TYPE;
  operator: PRICE_ALERT_OPERATOR;
  limit_price?: number;
  limit_percentage?: number;
  last_price: number;
  email_notification: boolean;
  is_recurrent: boolean;
  is_active: boolean;
  created_date?: string;
  modified_date?: string;
  is_email_notification?: boolean;
}
